import React from 'react';
import { makeClassName } from '@siteless/util';

const CloseIcon = ({
  className,
  ...rest
}: {
  className?: string;
  [x: string]: any;
}) => (
  <svg
    className={makeClassName('CloseIcon', className)}
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    xmlSpace="preserve"
    {...rest}
  >
    <path
      d="M6,19c-0.26,0-0.51-0.1-0.71-0.29c-0.39-0.39-0.39-1.02,0-1.41l12-12c0.39-0.39,1.02-0.39,1.41,0s0.39,1.02,0,1.41l-12,12
	C6.51,18.9,6.26,19,6,19z"
    />
    <path
      d="M18,19c-0.26,0-0.51-0.1-0.71-0.29l-12-12c-0.39-0.39-0.39-1.02,0-1.41s1.02-0.39,1.41,0l12,12c0.39,0.39,0.39,1.02,0,1.41
	C18.51,18.9,18.26,19,18,19z"
    />
  </svg>
);

export default CloseIcon;
